<template>
  <div>
    <vs-row v-if="$store.state.endorsementInvite.externalFeedback[responseStep - 1]">
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2" style="font-size: 0.8rem;">
        <h5
          v-if="$store.state.endorsementInvite.externalFeedback[responseStep - 1].currentGapText == 'NO GAP'"
          class="w-full text-center" style="color: #76C488;"
        >
         {{$t('Response.t1')}}
        </h5>
        <span v-else> {{$t('Response.t1')}}</span>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2" style="font-size: 0.8rem;">
        <h5
          v-if="$store.state.endorsementInvite.externalFeedback[responseStep - 1].currentGapText == 'SMALL GAP'"
          class="w-full text-center" style="color: #76C488;"
        >
          {{$t('Response.t2')}}
        </h5>
        <span v-else>{{$t('Response.t2')}}</span>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3" style="font-size: 0.8rem;">
        <h5
          v-if="$store.state.endorsementInvite.externalFeedback[responseStep - 1].currentGapText == 'MODERATE GAP'"
          class="w-full text-center" style="color: #76C488;"
        >
          {{$t('Response.t3')}}
        </h5>
        <span v-else> {{$t('Response.t3')}}</span>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2" style="font-size: 0.8rem;">
        <h5
          v-if="$store.state.endorsementInvite.externalFeedback[responseStep - 1].currentGapText == 'LARGE GAP'"
          class="w-full text-center" style="color: #76C488;"
        >
          {{$t('Response.t4')}}
        </h5>
        <span v-else>{{$t('Response.t4')}}</span>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3" style="font-size: 0.8rem;">
        <h5
          v-if="$store.state.endorsementInvite.externalFeedback[responseStep - 1].currentGapText == 'SIGNIFICANT GAP'"
          class="w-full text-center" style="color: #76C488;"
        >
          {{$t('Response.t5')}}
        </h5>
        <span v-else>{{$t('Response.t5')}}</span>
      </vs-col>
    </vs-row>
    <vs-row v-else>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2" style="font-size: 0.8rem;">
        {{$t('Response.t1')}}
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2" style="font-size: 0.8rem;">
        {{$t('Response.t2')}}
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3" style="font-size: 0.8rem;">
        {{$t('Response.t3')}}
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2" style="font-size: 0.8rem;">
        {{$t('Response.t4')}}
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3" style="font-size: 0.8rem;">
        {{$t('Response.t5')}}
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
export default {
  name: 'SliderValue',
  props: ['responseStep']
}
</script>

<style scoped>

</style>
